(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bmp-menu-review-stars"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = 'a[href*="trustpilot.com/review/"], a[href*="judge.me/reviews/"]';
    const decorate = (root) => {
      root.querySelectorAll(selector).forEach(link => {
        const walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT);
        const nodes = [];
        while (walker.nextNode()) {
          const node = walker.currentNode;
          if (!node.parentElement.closest('.bmp-menu-review-star') && /[⭐★]/u.test(node.data)) nodes.push(node);
        }
        nodes.forEach(node => {
          const fragment = document.createDocumentFragment();
          node.data.split(/([⭐★]\uFE0F?)/u).forEach(part => {
            if (/^[⭐★]/u.test(part)) {
              const star = document.createElement('span');
              star.className = 'bmp-menu-review-star';
              star.setAttribute('aria-hidden', 'true');
              star.textContent = '★';
              fragment.append(star);
            } else fragment.append(document.createTextNode(part));
          });
          node.replaceWith(fragment);
        });
      });
    };
    const observed = new WeakSet();
    const init = () => {
      document.querySelectorAll('header, header-drawer, footer, nav').forEach(root => {
        decorate(root);
        if (observed.has(root)) return;
        observed.add(root);
        new MutationObserver(() => decorate(root)).observe(root, { childList: true, subtree: true });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bmp-review-badges"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bmp-review-badges')) {
    customElements.define('bmp-review-badges', class extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('.product-information');
        if (!this.scope) return;
        this.refresh = this.refresh.bind(this);
        this.observer = new MutationObserver(this.refresh);
        this.observer.observe(this.scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-modal-json'] });
        this.menuObserver = new MutationObserver(this.refresh);
        this.refresh();
        document.addEventListener('shopify:section:load', this.refresh);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.menuObserver?.disconnect();
        this.menu = null;
        document.removeEventListener('shopify:section:load', this.refresh);
      }
      makeBadge(name, rating, href) {
        const link = document.createElement('a');
        link.className = 'bmp-review-badge';
        link.href = href;
        const number = new Intl.NumberFormat(document.documentElement.lang || 'da', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(rating);
        link.setAttribute('aria-label', `${name}: ${number} / 5`);
        const title = document.createElement('span');
        title.className = 'bmp-review-badge__name';
        title.textContent = name;
        const value = document.createElement('span');
        value.className = 'bmp-review-badge__rating';
        value.textContent = number;
        const stars = document.createElement('span');
        stars.className = 'bmp-review-badge__stars';
        stars.setAttribute('aria-hidden', 'true');
        stars.textContent = '★★★★★';
        const fill = document.createElement('span');
        fill.className = 'bmp-review-badge__stars-fill';
        fill.style.setProperty('--rating-fill', `${rating * 20}%`);
        fill.textContent = '★★★★★';
        stars.append(fill);
        value.append(stars);
        link.append(title, value);
        return link;
      }
      refresh() {
        const source = this.scope.querySelector('.jdgm-trust-badge-widget[data-modal-json]');
        if (!source) return;
        let judge;
        try { judge = JSON.parse(source.dataset.modalJson); } catch { return; }
        const judgeRating = Number(judge.average_rating);
        if (!(judgeRating > 0 && judgeRating <= 5)) return;
        const candidates = [...document.querySelectorAll('header a[href], .header a[href], header-drawer a[href], footer a[href]')];
        const menu = candidates.find(link => {
          try {
            const url = new URL(link.href);
            return /(^|\.)trustpilot\.com$/.test(url.hostname) && url.pathname.startsWith('/review/') && /trustpilot/i.test(link.textContent) && /(?:^|[^\d])([0-5](?:[.,]\d{1,2})?)(?![\d.,])/.test(link.textContent);
          } catch { return false; }
        });
        if (menu !== this.menu) {
          this.menuObserver.disconnect();
          this.menu = menu;
          if (menu) this.menuObserver.observe(menu, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['href'] });
        }
        const match = menu?.textContent.match(/(?:^|[^\d])([0-5](?:[.,]\d{1,2})?)(?![\d.,])/);
        const trustRating = match ? Number(match[1].replace(',', '.')) : NaN;
        const validTrust = trustRating > 0 && trustRating <= 5;
        const key = JSON.stringify([judgeRating, validTrust ? trustRating : null, menu?.href]);
        const wrapper = source.closest('.shopify-app-block') || source.closest('.jdgm-trust-badge-mount-host');
        if (!wrapper) return;
        const gallery = this.scope.querySelector('.product-information__media');
        if (!gallery) return;
        if (gallery.firstElementChild !== this) gallery.prepend(this);
        wrapper.dataset.bmpOriginalReviews = '';
        wrapper.hidden = true;
        this.hidden = false;
        if (this.dataset.state === key) return;
        this.dataset.state = key;
        const badges = [];
        if (validTrust) badges.push(this.makeBadge('Trustpilot', trustRating, menu.href));
        badges.push(this.makeBadge('Judge.me', judgeRating, 'https://judge.me/reviews/stores/www.garagecultureshop.dk'));
        this.replaceChildren(...badges);

      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-information-content"] && !Shopify.designMode) return;
  try {
    import('@shopify/events').then(({ StandardEvents }) => {

  class GCColorThumbnails extends HTMLElement {
    connectedCallback() {
      if (this.closest('#quick-add-modal-content')) return;
      this.controller?.abort();
      this.controller = new AbortController();
        this.swipeBusy = false;
      this.productRoot = this.closest('[data-product-grid-content]');
      if (!this.productRoot) return;
      const options = { signal: this.controller.signal };
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-color-value-id]');
        if (!button || !matchMedia('(min-width: 750px)').matches) return;
        const input = this.colorInputs().find((item) => item.dataset.optionValueId === button.dataset.colorValueId);
        if (input && !input.disabled) input.click();
        this.sync();
      }, options);
      this.productRoot.addEventListener('change', () => this.sync(), options);
      this.productRoot.addEventListener(StandardEvents.productSelect, (event) => {
        event.promise?.then(() => { requestAnimationFrame(() => { if (this.isConnected) this.sync(); }); }).catch(() => {});
      }, options);
      const gallery = this.closest('.product-information__media');
      if (gallery) {
        gallery.addEventListener('dragstart', (event) => {
          if (matchMedia('(max-width: 749px)').matches && !event.target.closest('dialog')) event.preventDefault();
        }, options);
        gallery.addEventListener('pointerdown', (event) => {
          this.gesture = null;
          if (!matchMedia('(max-width: 749px)').matches || !event.isPrimary || event.button !== 0 || event.target.closest('dialog') || event.target.closest('button:not(.product-media-container__zoom-button), a, input, select, textarea')) return;
          this.gesture = { x: event.clientX, y: event.clientY, id: event.pointerId, direction: null };
        }, { ...options, capture: true });
        gallery.addEventListener('pointermove', (event) => {
          if (!this.gesture || event.pointerId !== this.gesture.id) return;
          const dx = event.clientX - this.gesture.x;
          const dy = event.clientY - this.gesture.y;
          if (!this.gesture.direction && Math.max(Math.abs(dx), Math.abs(dy)) > 12) {
            this.gesture.direction = Math.abs(dx) > Math.abs(dy) * 1.3 ? 'horizontal' : 'vertical';
            if (this.gesture.direction === 'horizontal') gallery.setPointerCapture(event.pointerId);
          }
          if (this.gesture.direction === 'horizontal') {
            if (event.cancelable) event.preventDefault();
            event.stopPropagation();
          }
        }, { ...options, capture: true });
        gallery.addEventListener('pointerup', (event) => {
          const gesture = this.gesture;
          this.gesture = null;
          if (!gesture || event.pointerId !== gesture.id || gesture.direction !== 'horizontal') return;
          const dx = event.clientX - gesture.x;
          const dy = event.clientY - gesture.y;
          if (Math.abs(dx) < 45 || Math.abs(dx) <= Math.abs(dy) * 1.3) return;
          if (event.cancelable) event.preventDefault();
          event.stopPropagation();
          this.suppressClickUntil = performance.now() + 500;
          this.switchColor(dx < 0 ? 1 : -1);
        }, { ...options, capture: true });
        gallery.addEventListener('pointercancel', () => { this.gesture = null; }, options);
        gallery.addEventListener('click', (event) => {
          if (performance.now() < (this.suppressClickUntil || 0)) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { ...options, capture: true });
      }
      this.sync();
    }
    switchColor(direction) {
      if (this.swipeBusy) return;
      const inputs = this.colorInputs();
      const colors = Array.from(this.querySelectorAll('button[data-color-value-id]'))
        .map((button) => inputs.find((input) => input.dataset.optionValueId === button.dataset.colorValueId))
        .filter((input) => input && !input.disabled);
      if (colors.length < 2) return;
      const current = colors.findIndex((input) => input.checked);
      const next = colors[(Math.max(0, current) + direction + colors.length) % colors.length];
      this.swipeBusy = true;
      clearTimeout(this.swipeTimer);
      this.swipeTimer = setTimeout(() => { this.swipeBusy = false; }, 1200);
      next.click();
    }
    disconnectedCallback() { this.controller?.abort(); clearTimeout(this.swipeTimer); }
    colorInputs() {
      return Array.from(this.productRoot.querySelectorAll('.product-details variant-picker input[data-option-value-id]'));
    }
    sync() {
      const inputs = this.colorInputs();
      for (const button of this.querySelectorAll('button[data-color-value-id]')) {
        const input = inputs.find((item) => item.dataset.optionValueId === button.dataset.colorValueId);
        button.setAttribute('aria-pressed', String(Boolean(input?.checked)));
        button.disabled = !input || input.disabled;
      }
      const active = this.querySelector('[aria-pressed="true"]');
      const media = Array.from(this.productRoot.querySelectorAll('.media-gallery__grid > .product-media-container'));
      const unavailableSize = this.productRoot.querySelector('[data-bmp-size-fieldset] input:checked[data-option-available="false"]');
      const selectedMedia = active?.dataset.colorMediaId;
      const hasMatch = media.some((item) => item.querySelector('[data-media-id]')?.dataset.mediaId === selectedMedia);
      for (const item of media) {
        item.classList.toggle('gc-other-color-media', Boolean(unavailableSize && hasMatch && item.querySelector('[data-media-id]')?.dataset.mediaId !== selectedMedia));
      }
    }
  }
  if (!customElements.get('gc-color-thumbnails')) customElements.define('gc-color-thumbnails', GCColorThumbnails);
  });
  } catch(e) { console.error(e); }
})();

})();
